export function handleLogout() {
  localStorage.removeItem('accessToken');
  localStorage.setItem('adminAuthenticated', 'false');
  window.location.href = '/';
}
